import { z } from "zod";

export const auditInfoSchema = z.object({
    actor: z.string().nullable().optional(),
    timeStamp: z.string(),
});
export type AuditInfo = z.infer<typeof auditInfoSchema>;

export const addressSchema = z.object({
    street1: z.string(),
    street2: z.string().nullable().optional(),
    city: z.string(),
    region: z.string(),
    postalCode: z.string(),
    country: z.string(),
});
export type Address = z.infer<typeof addressSchema>;

export function exportListResponseSchema<T extends z.ZodTypeAny>(itemSchema: T) {
    return z.object({
        results: z.array(itemSchema),
        truncated: z.boolean(),
    });
}

export const emptyAddress: Address = {
    street1: "",
    city: "",
    region: "",
    postalCode: "",
    country: "",
};
